<div id="breadcrumb">
	<ol class="breadcrumb">
		<li ng-repeat="breadcrumb in ::ctrl.breadcrumbs track by $index" ng-class="{'active': $last, 'hidden-xs': !$first}">
			<span ng-if="$first">
				<a href="javascript:void(0);" ng-click="ctrl.go(breadcrumb)" title="Caut&#259; magazine Orange">Caut&#259; magazine</a>
			</span>
			<span ng-if="!$first && !$last">
				<a href="javascript:void(0);" ng-click="ctrl.go(breadcrumb)" title="{{::breadcrumb.text}}">{{::breadcrumb.text}}</a> 
			</span>
			<span ng-if="$last" title="{{::breadcrumb.text}}">{{::breadcrumb.text}}</span>
		</li>
	</ol>
</div>